var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10360",
    "data-name": "Group 10360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.172,
    height: 17.707,
    viewBox: "0 0 25.172 17.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4078",
    "data-name": "Rectangle 4078",
    width: 25.172,
    height: 17.707,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10359",
    "data-name": "Group 10359",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44420",
    "data-name": "Path 44420",
    d: "M12.52,0c2.412.084,4.825.155,7.237.259A18.957,18.957,0,0,1,21.97.5a3.162,3.162,0,0,1,2.785,2.759,32.037,32.037,0,0,1,.392,6.716c-.036,1.17-.135,2.338-.24,3.5a8.787,8.787,0,0,1-.281,1.543,3.2,3.2,0,0,1-2.815,2.282,72.31,72.31,0,0,1-7.62.382c-2.931.054-5.86-.019-8.786-.189-.749-.044-1.5-.132-2.239-.246A3.082,3.082,0,0,1,.41,14.6a24.1,24.1,0,0,1-.363-3.251c-.06-1.642-.066-3.289,0-4.93A23.654,23.654,0,0,1,.456,2.99,3.149,3.149,0,0,1,3.3.451a69.83,69.83,0,0,1,7.436-.38c.595-.011,1.19,0,1.784,0,0-.023,0-.046,0-.069M10.075,5.117V12.64l6.53-3.762-6.53-3.761",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5b1743166d9c59692d0edbdea8e1b43d.svg";
export { ForwardRef as ReactComponent };